module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Urgent-mail-2ed47810771fe62853ef1bbeca978696.svg";